import { useCallback, useState } from 'react';
import useSWR from 'swr';
import { SerpStoreReturnSnapshot } from '@/components/Approval/@components/SerpStoreReturn';
import SerpStoreReturnDetailDialog from '@/components/Approval/@components/SerpStoreReturn/DetailDialog';
import { getSerpStoreReturnDraftSourceUrl } from '@/constant/approval';
import { getNestedDataFetcher } from '@/utils/apis';
import {
  parseSerpContent,
  parseSerpDocumentRef,
} from '@/utils/approval/serpDocument';
import {
  parseSavedSerpReturnDetail,
  type SerpStoreReturnDraftSource,
} from '@/utils/approval/serpStoreReturn';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/**
 * 171 SERP 매장반품 요청 — 저장 content 그대로.
 * 「자세히 보기」는 저장된 작성 시점 상세, 상세가 없는 레거시 문서만 SERP 를 다시 조회(레거시 동작)
 */
const SerpStoreReturnSlot = ({ data }: ContentExtraProps) => {
  const [detailOpen, setDetailOpen] = useState(false);
  const openDetail = useCallback(() => setDetailOpen(true), []);

  const content = parseSerpContent(data.attributes);
  const savedDetail = parseSavedSerpReturnDetail(data.attributes);
  const ref = savedDetail ? null : parseSerpDocumentRef(data.attributes);
  const live = useSWR<SerpStoreReturnDraftSource>(
    detailOpen && ref
      ? getSerpStoreReturnDraftSourceUrl(ref.typeCode, ref.sequence)
      : null,
    getNestedDataFetcher,
    { revalidateOnFocus: false, shouldRetryOnError: false },
  );

  if (!content) return null;
  const liveSource = live.data?.display?.source ?? null;
  return (
    <ContentSlotRoot>
      <SerpStoreReturnSnapshot content={content} onOpenDetail={openDetail} />
      <SerpStoreReturnDetailDialog
        open={detailOpen}
        onClose={() => setDetailOpen(false)}
        source={savedDetail ?? liveSource}
        isLoading={live.isLoading}
        hasError={
          !savedDetail && (!ref || !!live.error || (!!live.data && !liveSource))
        }
      />
    </ContentSlotRoot>
  );
};

export default SerpStoreReturnSlot;
